/* eslint-disable no-console */
import * as stores from '../store/modules';
import { isEmpty, isString, startCase, isFunction, isArray } from 'lodash';
export default {
    inserted: function (el, binding) {
        let redirectOnEmptyUrl = el.getAttribute('redirect-on-empty');

        if(!binding.arg || !isString(binding.value)) {
            el.remove();
            return;
        }

        const storeName = `${startCase(binding.arg).replace(' ', '')}Module`;
        const store = isEmpty(stores[storeName]) ? null : stores[storeName];

        if(!store || isEmpty(store.state)) {
            return;
        }

        if(isFunction(store.mutations.initializeStore)) {
            store.mutations.initializeStore();
        }

        const value = store.state[binding.value];

        if(isString(value)) {
            el.value = value;
        }

        if(isArray(value)) {
            value.forEach((v, i) => {
                if(i === 0) {
                    el.value = v;
                } else {
                    var input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = el.name;
                    input.value = v;
                    el.insertAdjacentElement('afterend', input);
                }
            });
        }

        if(redirectOnEmptyUrl && isEmpty(value)) {
            window.location.href = redirectOnEmptyUrl;
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/directives/from-store.js